import LogoTitle from '../../assets/images/logo-s.png';
import {BrowserRouter, Link, useNavigate, Navigate} from 'react-router-dom';
import './index.scss';
import {useState, useEffect} from 'react';
import {AnimatedLetters} from '../AnimatedLetters';
import {Logo} from './Logo';
import Loader from 'react-loaders';
import ReactTouchEvents from "react-touch-events";

export const Home = () => {

    const [letterClass, setLetterClass] = useState('text-animate');
    const nameArray = ('tikhin  alexandr').split(' ');
    const jobArray = ('fullstack  developper.').split(' ');

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover');
        }, 4000)

    }, [])

    const handleTap = () => {
        let navigate = useNavigate
        navigate('/contact')
    }

    return (
        <>
            <div className="container home-page">
                <div className="text-zone">
                    <h1>
                        <span className={letterClass}>Hi,</span>
                        <br/>
                        <span className={`${letterClass} _12`}>I'm</span>
                        <img src={LogoTitle} style={{width: '100px', height: 'auto', margin: '-20px'}}
                             alt="developper"/>
                        <AnimatedLetters letterClass={letterClass} strArray={nameArray} idx={13}/>
                        <br/>
                        <AnimatedLetters letterClass={letterClass} strArray={jobArray} idx={22}/>
                    </h1>
                    <h2>React / Typescript / Node.JS / Express.JS / UX & UI</h2>
                    <Link to="/contact" className='flat-button'>CONTACT ME</Link>
                </div>
                <Logo/>
            </div>
            <Loader type='pacman'/>
        </>
    )
}
